Ext.define('SA.VectorMapChoroplethLayerProperties', {
    singleton: true,

    get({attributes, legendBreaks}) {
        var attribute = attributes.selected;

        if (!attribute || !legendBreaks) {
            return {visible: false};
        }

        return {fillColor: SA.VectorMapColorExpressions.stepColor(attribute, legendBreaks), visible: true};
    }
});